module.exports = __webpack_public_path__ + "static/media/MainTable.e595a7ad.PNG";